import React from "react";
import cs from "classnames";

import GlobalNavigation from "../../../../molecules/GlobalNavigation";
import ProfileMenu from "../../../../molecules/ProfileMenu";
import classes from "./LinearMenu.module.scss";
import { scrollToTop } from "../../../../../utilities/helpers";
import MaorCredit from "../../../../molecules/MaorCredit";
import { LOCALES, useLocale } from "../../../../../hooks/useLocale/useLocale";
import ProfileMenuHeb from "../../../../molecules/ProfileMenuHeb/ProfileMenuHeb";

const LinearMenu = () => {
  const locale = useLocale(); // Get the locale from domain
  const isRTL = locale === LOCALES.HE; // Check if Hebrew (RTL)

  return (
    <div className="d-flex ai-center">
    {isRTL ? "" : <>  <nav className={cs(isRTL ? "mr-auto" : "ml-auto")}>
        <GlobalNavigation onClick={() => scrollToTop()} />
      </nav></>}
    
      <div
        className={cs(
          classes.profile,
          "d-flex jc-end ai-center",
          isRTL ? "" : "ml-auto"
        )}
      >
        {!isRTL ? (
          <div className="mr-05">
            <MaorCredit />
          </div>
        ) : (
          ""
        )}

        {isRTL ? (
          <ProfileMenuHeb id="modal-menu-profile-menu" />
        ) : (
          <ProfileMenu id="modal-menu-profile-menu" />
        )}
      </div>
    </div>
  );
};

export default LinearMenu;
